<script setup lang="ts">
import logoUrl from '@/assets/top-nav/unifii-logo.webp'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { computed, ref } from 'vue'
import {
  faIdCardAlt,
  faUserCircle,
  faListAlt,
  faSignOutAlt,
  faListUl,
  faChevronDown,
  faInventory,
  faHandHoldingBox,
  faTasks
} from '@fortawesome/pro-regular-svg-icons'
import { useAuthenticatedUser } from "@/composables/authenticated-user";
import { makeCoreUrl } from "@/router/helpers";

const logout = () => window.location.href = "http://localhost:31015/Account/LogOff"
const authenticatedUser = useAuthenticatedUser()
const showSecondaryNav = computed(() => false /* authenticatedUser.data.value !== undefined */)
const showUserActions = computed(() => false /* authenticatedUser.data.value !== undefined */)
const activeNav = ref('')
const navs = [
  [
    { key: 'site-info', display: 'Site Info' },
    { key: 'utility-info', display: 'Utility Info' },
    { key: 'site-layout', display: 'Site Layout' },
    { key: 'deals', display: 'Deals' },
    { key: 'budget', display: 'Budget' }
  ],
  [
    { key: 'contacts', display: 'Contacts' },
    { key: 'docs', display: 'Documents' }
  ]
]

const setActiveNav = (to: string) => activeNav.value = to

</script>

<template>
  <div class="top-nav--container">
    <nav class="navbar navbar-expand top-nav--primary">
      <div class="container-fluid mt-1 mb-1">
        <a :href="makeCoreUrl('')" class="navbar-brand">
          <img :src="logoUrl" height="27" alt="Unifii logo">
        </a>
        <ul class="navbar-nav align-items-center" v-if="showUserActions">
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <FontAwesomeIcon :icon="faUserCircle" />
            </a>
            <ul class="dropdown-menu shadow-sm dropdown-menu-end">
              <li>
                <a class="dropdown-item" href="#/users/me">
                  <FontAwesomeIcon :icon="faIdCardAlt" class="me-1" />
                  My Profile
                </a>
              </li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li>
                <a class="dropdown-item" href="#/legal/terms-of-use">
                  <FontAwesomeIcon :icon="faListAlt" class="me-1" />
                  Terms of use
                </a>
              </li>
              <li>
                <a class="dropdown-item" href="http://localhost:31015/Account/LogOff">
                  <FontAwesomeIcon :icon="faSignOutAlt" class="me-1" />
                  Log out
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>

    <nav class="navbar navbar-expand top-nav--secondary pt-0 pb-0" v-if="showSecondaryNav">
      <div class="container-fluid justify-content-start">
        <div class="dropdown">
          <a href="#" class="ps-4 pe-4" data-bs-toggle="dropdown">
            <FontAwesomeIcon :icon="faListUl" class="me-1" />
            My Projects
            <FontAwesomeIcon :icon="faChevronDown" class="ps-4" />
          </a>
          <ul class="dropdown-menu">
            <li>
              <a href="#" class="dropdown-item">
                <FontAwesomeIcon :icon="faListUl" class="me-1" />
                My Projects
              </a>
            </li>
            <li>
              <a href="#" class="dropdown-item">
                <FontAwesomeIcon :icon="faInventory" class="me-1" />
                Manage Deals
              </a>
            </li>
            <li>
              <a href="#" class="dropdown-item">
                <FontAwesomeIcon :icon="faHandHoldingBox" class="me-1" />
                Project Delivery
              </a>
            </li>
            <li>
              <a href="#" class="dropdown-item">
                <FontAwesomeIcon :icon="faTasks" class="me-1" />
                Asset Management
              </a>
            </li>
          </ul>
        </div>
        <ul class="navbar-nav ms-4 ps-4" v-for="(nav, index) in navs" :key="index">
          <li v-for="n in nav" :key="n.key">
            <a href="#" @click="setActiveNav(n.key)" :class="{'nav-link': true, 'active': n.key === activeNav}">
              {{ n.display }}
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<style lang="scss">
.top-nav--container {
  position: sticky;
  top: 0;

  .top-nav--primary {
    padding: 0;
    background: #103A48;

    .navbar-nav {
      height: 50px;
    }

    .dropdown > a {
      font-size: 21px;
      color: #fff;
      padding-top: 0;
      padding-bottom: 0;
    }

    .navbar-brand {
      line-height: 0;
    }
  }

  .top-nav--secondary {
    background: transparent linear-gradient(90deg, #28a09c 0%, #fee351 100%) 0 0 no-repeat padding-box;
    //height: 45px;

    .dropdown > a {
      color: #fff;
      text-decoration: none;
      text-transform: uppercase;
      padding: 0.85rem 1.5rem;
    }

    .navbar-nav {
      border-left: 1px solid rgba(255, 255, 255, 0.25);
    }

    .nav-link {
      text-transform: uppercase;
      color: #fff;
      padding: 0.85rem 1.5rem;
      text-shadow: 0 0 5px #0E3A47;
      transition: none;

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }

      &.active {
        color: #6D6E71;
        font-weight: bold;
        text-shadow: none;
        background: #fff;
      }
    }
  }
}
</style>
